import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { ROUTES } from "../../constants";

function NotFound() {
  const user = useSelector((state) => state.auth.user);
  const homeRoute = user?.isRTA ? ROUTES.IEPFReport : ROUTES.DASHBOARD;

  return (
    <div style={{
      minHeight: "60vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: 24,
    }}>
      <div style={{ fontSize: 96, fontWeight: 700, lineHeight: 1, color: "#9e9e9e" }}>404</div>
      <div style={{ fontSize: 24, marginTop: 8, fontWeight: 600 }}>Page not found</div>
      <div style={{ color: "#616161", marginTop: 8, maxWidth: 520 }}>
        The page you are looking for doesn’t exist or has been moved.
      </div>
      <div style={{ marginTop: 24 }}>
        <Link to={homeRoute} style={{
          background: "#1976d2",
          color: "#fff",
          padding: "10px 16px",
          borderRadius: 6,
          textDecoration: "none",
          display: "inline-block",
        }}>
          Back to Home
        </Link>
      </div>
    </div>
  );
}

export default NotFound;


